import { render, staticRenderFns } from "./BxDonutChart.vue?vue&type=template&id=0b59c903&"
import script from "./BxDonutChart.vue?vue&type=script&lang=js&"
export * from "./BxDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports